const firebaseConfig = {
    apiKey: "AIzaSyAHKgXjDfhDn6Sn4AYhgukL-VFe7PSvtCE",
    authDomain: "m-genius-car-mechanic.firebaseapp.com",
    projectId: "m-genius-car-mechanic",
    storageBucket: "m-genius-car-mechanic.appspot.com",
    messagingSenderId: "854192761732",
    appId: "1:854192761732:web:60862d588c3c90d6140bd1",
};

export default firebaseConfig;